import {
  BupInboxPage,
  BupSendPage,
  BupDirectPage,
  BupArchivedPage,
} from '@BUP/pages';
import {
  Route,
  useRouteMatch,
  Switch,
  Redirect
} from 'react-router-dom';
import { RoleRoute } from '@BUP/routes';


const ModeBupNavigation = () => {
  const match = useRouteMatch();

  return (
    <Switch>
      <RoleRoute
        name="BupInboxPage"
        component={BupInboxPage}
        path={`${match.path}/inbox`}
        exact
      />
      <RoleRoute
        name="BupSendPage"
        component={BupSendPage}
        path={`${match.path}/send`}
        exact
      />
      <RoleRoute
        name="BupDirectPage"
        component={BupDirectPage}
        path={`${match.path}/direct`}
        exact
      />
      <RoleRoute
        name="BupArchivedPage"
        component={BupArchivedPage}
        path={`${match.path}/archived`}
        exact
      />
      <Route>
        <Redirect to="/modebup/send" />
      </Route>
    </Switch>
  )
}

export default ModeBupNavigation;